import classnames from 'classnames';
import { generateConditionalArray } from 'helpers/array';
import { BEMBlock } from 'helpers/classnames';
import * as React from 'react';
import { Button } from 'palette/Button';
import { FilterMobileActionsLabels } from 'palette/Filters/types';
import { IconName } from 'palette/Icon';
import './FilterMobileActions.scss';

interface FilterMobileActionsProps {
    id?: string;
    className?: string;
    labels?: FilterMobileActionsLabels;
    onFiltersClick: React.MouseEventHandler<HTMLButtonElement>;
    onSortClick: React.MouseEventHandler<HTMLButtonElement>;
    onCategoryClick?: React.MouseEventHandler<HTMLButtonElement>;
    count: number;
}

interface ActionButtonProps {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    label: string;
    iconName: IconName;
    className?: string;
}

function ActionButton({
    onClick,
    label,
    iconName,
    className,
}: ActionButtonProps) {
    return (
        <Button
            isExpanded
            className={className}
            iconName={iconName}
            iconPosition="left"
            label={label}
            size="medium"
            theme="secondary"
            onClick={onClick}
        />
    );
}

export default function FilterMobileActions({
    id,
    className,
    labels,
    onFiltersClick,
    onSortClick,
    onCategoryClick,
    count,
}: FilterMobileActionsProps) {
    const [block, BEMElement] = BEMBlock('filter-mobile-actions', {
        'three-columns': !!onCategoryClick,
    });
    const hasFiltersApplied = count > 0;
    const filtersLabel = `${labels?.filters ?? 'Filters'}${hasFiltersApplied ? ` (${count})` : ''}`;
    return (
        <div
            className={classnames(block, className)}
            {...id && { id }}
        >
            {
                generateConditionalArray<ActionButtonProps>([
                    {
                        condition: !!onCategoryClick,
                        entries: [{
                            iconName: 'palette_grid',
                            onClick: onCategoryClick,
                            label: labels?.categories ?? 'Categories',
                        }],
                    },
                    {
                        entries: [
                            {
                                iconName: 'palette_list_check',
                                onClick: onFiltersClick,
                                label: filtersLabel,
                            },
                            {
                                iconName: 'palette_sort',
                                onClick: onSortClick,
                                label: labels?.sorting ?? 'Sorting',
                            },
                        ],
                    },
                ]).map(actionButtonProps => (
                    <ActionButton
                        key={actionButtonProps.iconName}
                        className={BEMElement('button', { [`${actionButtonProps.iconName}`]: true })}
                        {...actionButtonProps}
                    />
                ))

            }
        </div>
    );
}
